export default accountUrl => ({
  automationKey: 'LogoutCTA',
  href: `${accountUrl}/logout`,
  label: 'Log out',
});
